<template>
  <div>
    <div class="row">
      <div class="col-12">
        <g-table-sync
          app="partes"
          view="partes_list"
          pagination="default"
          :default-limit="12"
          :columns="columns"
          @edit="openForm"
        >
          <template
            slot="ParteTurno"
            slot-scope="item"
          >
            <a-tag
              v-if="item.ParteTurno == 0"
              :color="$colors['blue-light']"
            >
              <fa-icon :icon="['far', 'sun']" /> Mañana
            </a-tag>
            <a-tag
              v-else-if="item.ParteTurno == 1"
              :color="$colors.orange"
            >
              <fa-icon :icon="['far', 'sun']" /> Tarde
            </a-tag>
            <a-tag
              v-else-if="item.ParteTurno == 2"
              :color="$colors.black"
            >
              <fa-icon :icon="['far', 'moon']" /> Noche
            </a-tag>
          </template>

          <template
            slot="PartePiezasOk"
            slot-scope="item"
          >
            <a-tag
              :color="$colors.success"
              class="font-size-14 font-weight-bold"
            >
              <fa-icon :icon="['fa', 'check']" /> {{ item.PartePiezasOk }}
            </a-tag>
          </template>

          <template
            slot="PartePiezasKo"
            slot-scope="item"
          >
            <a-tag
              :color="$colors.danger"
              class="font-size-14 font-weight-bold"
            >
              <fa-icon :icon="['fa', 'times']" /> {{ item.PartePiezasKo }}
            </a-tag>
          </template>

          <template
            v-if="$gestios.auth.check({ scopes: ['_BOSS'] })"
            slot="head-left"
          >
            <a-button
              v-show="!exportEnabled"
              class="mr-2"
              :loading="exportLoading"
              @click="exportEnabled = true"
            >
              <fa-icon
                v-show="!exportLoading"
                :icon="['far', 'file-excel']"
                class="mr-2"
              /> Exportar
            </a-button>
            <a-button
              v-show="exportEnabled"
              class="mr-2"
              :loading="exportLoading"
              @click="exportEnabled = false"
            >
              <fa-icon
                v-show="!exportLoading"
                :icon="['fa', 'times']"
                class="mr-2"
              /> Cerrar
            </a-button>

            <a-range-picker
              v-show="exportEnabled"
              v-model="exportDates"
              :disabled-date="disabledDate"
              :open="exportEnabled"
              :placeholder="['Desde', 'Hasta']"
            >
              <template slot="renderExtraFooter">
                <div class="w-100 text-right">
                  <a-button
                    v-if="exportDates"
                    :loading="exportLoading"
                    type="primary"
                    @click="exportData"
                  >
                    <fa-icon
                      v-show="!exportLoading"
                      :icon="['far', 'file-excel']"
                      class="mr-2"
                    /> Descargar
                  </a-button>
                  <span v-else>Especifica las fechas de exportación</span>
                </div>
              </template>
            </a-range-picker>
          </template>
        </g-table-sync>
      </div>
    </div>

    <partes-form
      :id="id"
      ref="form"
      :visible="formEnabled"
      @close="closeForm"
    />
  </div>
</template>

<script>
import partesForm from './form';

export default {
	name: 'MarasPartes',
	components: { partesForm },
	data() {
		return {
			exportDates: null,
			exportEnabled: false,
			exportLoading: false,
			formEnabled: false,
			id: 0,
			columns: [
				{
					title: 'Usuario',
					index: '_EntityCreateUser',
					slot: '_user'
				},
				{
					title: 'Fecha',
					index: 'ParteFecha',
					slot: '_date',
					order: true
				},
				{
					title: 'Horas',
					index: 'ParteHoras',
					order: true,
					align: 'center',
					search: true
				},
				{
					title: 'Turno',
					index: 'ParteTurno',
					order: true,
					slot: 'ParteTurno',
					filters: [
						{
							text: 'Mañana',
							value: '0'
						},
						{
							text: 'Tarde',
							value: '1'
						},
						{
							text: 'Noche',
							value: '2'
						}
					]
				},
				{
					title: 'Referencia',
					index: 'ParteReferencia',
					search: true
				},
				{
					title: 'Piezas OK',
					index: 'PartePiezasOk',
					slot: 'PartePiezasOk',
					order: true
				},
				{
					title: 'Piezas KO',
					index: 'PartePiezasKo',
					slot: 'PartePiezasKo',
					order: true
				},
				{
					title: 'Acciones',
					slot: '_actions'
				}
			]
		};
	},
	computed: {

	},
	async created() {
		this.$hub.$on('newPart', () => {
			this.id = 0;
			this.formEnabled = true;
		});
	},
	beforeDestroy() {
		this.$hub.$off('newPart');
	},
	methods: {
		openForm(item) {
			this.id = item._EntityId;
			this.formEnabled = true;
		},
		closeForm() {
			this.id = 0;
			this.formEnabled = false;
		},
		async exportData() {
			if (this.$gestios.auth.check({ scopes: ['_BOSS'] })) {
				this.exportLoading = true;

				const params = {
					from: this.exportDates[0].format('YYYY-MM-DD'),
					to: this.exportDates[1].format('YYYY-MM-DD')
				};

				try {
					const response = await this.$lambda.get(`works/excel?from=${params.from}&to=${params.to}`, { responseType: 'blob' });

					if (response.ok) {
						this.$message.success('Exportación finalizada. Descargando fichero...');

						const url = window.URL.createObjectURL(new Blob([response.data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', `Partes de ${this.exportDates[0].format('LL')} a ${this.exportDates[1].format('LL')}.xlsx`);
						document.body.appendChild(link);
						link.click();
						link.parentNode.removeChild(link);
					} else {
						this.$toast.error(response.message);
					}
				} catch (err) {
					this.$message.error('Ocurrió un error en la exportacion de los partes');
				}

				this.exportEnabled = false;
				this.exportLoading = false;
			}
		},
		disabledDate(current) {
			return current && current > this.$moment().startOf('day').add(1, 'days');
		}
	}
};
</script>

<style lang="scss"></style>
